import React from 'react';
import FloatingHero from '../../../../components/user/general/banner/Banner.js';
import aboutbannerImg from '../../../../assets/images/home/aboutbanner.jpg';
const AboutUsBanner = () => {
  return (
    <>
      <FloatingHero
        title="About Our Company"
        subtitle="Leading the agricultural equipment industry since 1990"
        backgroundImage={aboutbannerImg}
        darkOverlay={0.6}
      />
      {/* Rest of page content */}
    </>
  );
};

export default  AboutUsBanner;
